import './App.css'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import GBCRHeader from './components/Header/gbcr'
import GBCRFooter from './components/Footer/gbcr'
import AuthV2 from './scenes/AuthorizationV2/index'
import NotAuthorizedV2 from './scenes/AuthorizationV2/scenes/NotAuthorized/index'
import NoAuthorizedSuccessV2 from './scenes/AuthorizationV2/scenes/NoAuthorizedSuccess/index'
import DeliveryBookingEmailConfirmV2 from './scenes/DeliveryBooking/scenes/DeliveryBookingEmailConfirmV2/index'
import ReleaseAgentEmailConfirmV2 from './scenes/ReleaseRequest/scenes/ReleaseAgentV2/scenes/ReleaseAgentEmailConfirm/index'
import Admin from './scenes/Admin/index.js'
import ErrorPage from './scenes/Error/index.js'
import NoPermissionPage from './scenes/Error/NoPermission/index.js'

function App () {
  const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest} render={props => (
        sessionStorage.getItem('containerInfos_unchoice') ? (
          <Component {...props} />
        ) : (
          <Redirect to={{
            pathname: '/',
            state: { from: props.location }
          }}
          />
        )
      )}
    />
  )

  return (
    <>
      <GBCRHeader />
      <BrowserRouter>
        <div>
          <Switch>
            <Route
              path='/release_agent_email_confirm'
              exact
              component={ReleaseAgentEmailConfirmV2}
            />
            <Route
              path='/gbcr/release_agent_email_confirm'
              exact
              component={ReleaseAgentEmailConfirmV2}
            />
            <Route
              path='/delivery_booking_email_confirm'
              exact
              component={DeliveryBookingEmailConfirmV2}
            />
            <Route
              path='/gbcr/delivery_booking_email_confirm'
              exact
              component={DeliveryBookingEmailConfirmV2}
            />
            {/* <PrivateRoute
              path='/delivery-booking-success'
              exact
              component={DeliveryBookingSuccess}
            /> */}
            {/* <PrivateRoute
              path='/customer-enquiry'
              exact
              component={CustomerEnquiry}
            /> */}
            {/* <PrivateRoute
              path='/customs-brokerage'
              exact
              component={CustomsBrokerage}
            /> */}
            {/* <PrivateRoute
              path='/release_instruction'
              exact
              component={ReleaseInstruction}
            /> */}
            {/* <Route path='/terms' exact component={Terms} /> */}
            {/* <PrivateRoute
              path='/delivery-booking'
              exact
              component={DeliveryBooking}
            /> */}
            {/* <PrivateRoute
              path='/release-request-failure'
              exact
              component={RequestFailure}
            /> */}
            {/* <PrivateRoute
              path='/release_agent_success'
              exact
              component={RequestAgentSuccess}
            /> */}
            {/* <PrivateRoute path='/release-pin' exact component={RequestPIN} /> */}
            {/* <PrivateRoute
              path='/search-results'
              exact
              component={SearchResults}
            /> */}
            {/* <PrivateRoute path='/find-containers' exact component={FindCntr} /> */}
            <PrivateRoute
              path='/not-authorized'
              exact
              component={NotAuthorizedV2}
            />
            {/* <PrivateRoute
              path='/gbcr/not-authorized'
              exact
              component={NotAuthorizedV2}
            /> */}
            {/* <PrivateRoute
              path='/release_pin_success'
              exact
              component={RequestPINSuccess}
            /> */}
            {/* <PrivateRoute
              path='/enquiry_success'
              exact
              component={EnquirySuccess}
            /> */}
            {/* <PrivateRoute
              path='/customs_brokerage_success'
              exact
              component={CustomsBrokerageSuccess}
            /> */}
            <PrivateRoute
              path='/not-authorized-success'
              exact
              component={NoAuthorizedSuccessV2}
            />
            {/* <PrivateRoute
              path='/gbcr/not-authorized-success'
              exact
              component={NoAuthorizedSuccessV2}
            /> */}
            <Route
              path='/admin/home'
              exact
              component={Admin}
            />
            {/* <Route
              path='/admin/insert-email-white-list'
              exact
              component={InsertEmailWhiteList}
            /> */}
            <Route path='/' exact component={AuthV2} />
            <Route path='/gbcr' render={() => <Redirect to="/" />} />
            <Route path='/err' exact component={ErrorPage} />
            <Route path='/admin/no-permission' exact component={NoPermissionPage} />
            <Route render={() => <Redirect to="/err" />} />
          </Switch>
        </div>
      </BrowserRouter>
      <GBCRFooter />
    </>
  )
}

export default App
